import { EmployerLeadCreateRequest } from '../../types/employer/EmployerLead';

class EmployerLeadService {
  static async create(data: EmployerLeadCreateRequest): Promise<void> {
    const response = await fetch('/v2/public/employer/leads', {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  }
}

export { EmployerLeadService };
